import { request } from "../../core";

export function getAllSystemRelease() {
  return request.post({
    url: "/api/ums/sysRelease/getAllSystemRelease",
  });
};
